import { GetRouteData } from 'data/routeData';

export const getEffectiveSelectedPath = (location) => {
  const pathname = location?.pathname || window.location.pathname;
  if (pathname !== '/system/globalactions') return pathname;

  const scope = location?.state?.alarmShareContext?.scope;
  if (scope === 'history') return '/overwatch/alarmhistory';
  if (scope === 'pending') return '/overwatch/pendingalarms';

  return pathname;
};

export const buildSidebarData = (perms) =>
  GetRouteData(perms).map((item) => {
    const hasPerm = item.permission();
    const options = item.options.map((option) => {
      if (!hasPerm) return { ...option, enabled: false };
      if (option.hideSidebar) return { ...option };

      return { ...option, enabled: option.permission() };
    });

    return {
      ...item,
      enabled: hasPerm ? item.enabled : false,
      options,
    };
  });

export const isDropdownSelected = (dropdown, selectedPage) =>
  dropdown.options.some((option) => option.enabled !== false && option.href === selectedPage);

export const findOpenDropdownName = (pageButtons, selectedPage) =>
  pageButtons.find((dropdown) => dropdown.enabled && isDropdownSelected(dropdown, selectedPage))
    ?.name || null;
